import angular from 'angular';
import createPQRSModal from '../pqrs-form-modal/pqrs-form-modal.view.html';
let inject = [
  '$scope',
  'PqrsListService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$timeout',
  '$window',
  'NgTableParams',
  'ngAuthSettings'
];

class PqrsListController{
  constructor ($scope, PqrsListService, $state, $rootScope, SharedService, $uibModal, $timeout, $window, NgTableParams, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.NgTableParams = NgTableParams;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.PqrsListService = PqrsListService;
    this.ngAuthSettings = ngAuthSettings;
    this.SharedService = SharedService;
    this.pqrsList = null;
    this.responsable = false;
    this.state = {};
    this.statistics = [
      {
        'state': 'Casos Registrados',
        'total': 0,
        'bgcolor': 'bg-aqua'
      },
      {
        'state': 'Casos Sin Revisar',
        'total': 0,
        'bgcolor': 'bg-yellow'
      },
      {
        // 'state': 'Casos En Verificación',
        'state': 'Casos En Proceso',
        'total': 0,
        'bgcolor': 'bg-red'
      },
      {
        'state': 'Casos Cerrados',
        'total': 0,
        'bgcolor': 'bg-green'
      }
    ];
    this.pqrsId = null;
    this.ngTableConfig = null;
    this.ngTableCols = null;
  }

  $onInit(){
    this.getPQRSList();
  }

  exportCSV(table) {
    let userId = this.shCtrl.globals.currentUser.userId;
    let a = '';
    
    let tableConfig = this.ngTableConfig;
    if (!tableConfig) return alert('Ocurrió un error al exportar XLS');
    tableConfig.data.forEach((val, index) => {
      if (index > 0) {
        a += "," + val.id;
      } else {
        a += val.id;
      }
    });

    this.$window.location =  this.shCtrl.ngAuthSettings.config.env.apiEndPoint + this.ngAuthSettings.config.paths.PQRS.EXPORT_CSV+'?incidencias=' + a + '&userId=' + userId;
  }
  
  showModalFormPQRS () {
    let options = {
      globals : this.shCtrl.globals
    };
    let modalInstance = this.$uibModal.open({
      animation: true,
      static : true,
      template: createPQRSModal,
      keyboard : false,
      controller : 'PqrsFormModalController',
      controllerAs : 'mdCtrl',
      size: 'lg',
      resolve : {
        modalOptions : () => options
      }
    });
  }

  initNgTable() {
    this.ngTableCols = [
      {
        field: "id",
        title: "Caso",
        sortable: "id",
        filter: { "id": "text" },
        show: true
      },
      {
        field: "registeredDate",
        title: "Registrado el",
        filter: { "registeredDate": "text" },
        sortable: "registeredDate",
        show: true
      },
      {
        field: "subject",
        title: "Asunto",
        sortable: "subject",
        filter: { "subject": "text" },
        show: true
      },
      {
        field: "relatedWith",
        title: "Relacionado",
        filter: { "relatedWith": "text" },
        sortable: "relatedWith",
        show: true
      },
      {
        field: "incidenceDate",
        title: "Fecha Incidente",
        filter: { "incidenceDate": "text" },
        sortable: "incidenceDate",
        show: true
      },
      {
        field: "incidenceLocation",
        title: "Lugar del Incidente",
        filter: { "incidenceLocation": "text" },
        sortable: "incidenceLocation",
        show: true
      },
      // {
      //   field: "thirdTypeName",
      //   title: "Tipo Tercero",
      //   filter: { "thirdTypeName": "text" },
      //   sortable: "thirdTypeName",
      //   show: this.responsable || this.pqrsMaster
      // },
      {
        field: "branchCustomer",
        // title: "Sucursal / Cliente",
        title: "Tercero / Sucursal",
        filter: { "thirdPartyName": "text" },
        sortable: "thirdPartyName",
        show: this.isSupervisor
      },
      {
        field: "state",
        title: "Estado",
        filter: { "state": "text" },
        sortable: "state",
        show: true
      },
      {
        field: "comments",
        title: "Comentario",
        filter: { "comments": "text" },
        sortable: "comments",
        show: false
      },
      {
        field: "documentRelated",
        title: "Documento Relacionado",
        filter: { "documentRelated": "text" },
        sortable: "documentRelated",
        show: false
      },
      {
        field: "documentNumber",
        title: "Nro. Documento",
        filter: { "documentNumber": "text" },
        sortable: "documentNumber",
        show: false
      },
      {
        field: "actions",
        show: true
      }
    ];

    let initialParams = {
      count: 8
    };

    let initialSettings = {
      counts: [10, 20, 40, 100],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.pqrsList
    };

    this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
  }

  getPQRSList() {
    this.state = {};
    this.state.loading = true;
    let userId = this.shCtrl.globals.currentUser.userId;
    this.PqrsListService.getPQRSList(userId).then(({data}) => {
      this.pqrsList = data.pqrsList;
      this.responsable = data.responsable;
      // this.isSupervisor = $rootScope.globals.currentUser.isSupervisor;
      this.isSupervisor = this.responsable;
      this.pqrsList.forEach((val, inx) => { // TODO: Unificar el valor con los datos enviados desde el backend
        val.branchCustomer = val.branchName + ' / ' + val.thirdPartyName;
      });
      this.setStatistics(data.statistics);
      this.initNgTable();

      this.state.loading = false;
      this.state.loaded = true;
    }).catch(error => {
      this.state.loading = false;
      this.state.loaded = true;
      this.state.error = true;
    });
  }

  setStatistics(statistics) {
    let total = 0;

    angular.forEach(statistics, (value, key) => {
      let index = value.state - 1;

      if (this.statistics[value.state]) {
        this.statistics[value.state].total = value.total;
      }
      total += Number(value.total);
    });
    this.statistics[0].total = total;
  }

  setModalPqrsId(pqrsId){
    this.modalPqrsId = pqrsId;
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

PqrsListController.$inject = inject;

export default PqrsListController;




// WEBPACK FOOTER //
// ./www/components/pqrs/pqrs-list/pqrs-list.controller.js